import { getPublicSettings } from "@ea/api_client/api/endpoints/internalSettings";
import { createQuery } from "./apiHooks";

export const useGetPublicSettings = createQuery(getPublicSettings, {
  queryKey: ["PublicSettings", "Get"],
});
